module.exports = __webpack_public_path__ + "static/media/Fitmonkie_5_A-maze Midline Racerback Bra (MD Series).04c141a3.jpeg";